<template>
  <v-dialog
    v-model="opened"
    width="400"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card block flat>
      <v-card-title>
        <span class="title">Edit Reminders</span>
        <v-spacer />
      </v-card-title>

      <v-card-text>
        <v-layout class="">
          <v-flex xs12>
            <div>
              Would you like to enable or disable reminders for the selected
              questionnaires?
            </div>
          </v-flex>
        </v-layout>

        <v-layout class="font-italic">
          <v-flex xs12>
            <div>Note: they are enabled by default.</div>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          class="primary text-none"
          :disabled="savingQuestionnaires"
          @click="() => saveQuestionnaires(false)"
        >
          Enable
        </v-btn>

        <v-btn
          class="error white-text text-none"
          :disabled="savingQuestionnaires"
          @click="() => saveQuestionnaires(true)"
        >
          Disable
        </v-btn>

        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import API from '@/api';
import moment from 'moment';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    selectedQuestionnaires: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      savingQuestionnaires: false,
    };
  },

  methods: {
    async saveQuestionnaires(remindersDisabled) {
      this.savingQuestionnaires = true;

      try {
        const response = await API.questionnaire.saveQuestionnaires({
          questionnaireIds: this.selectedQuestionnaires.map(q => q.id),
          remindersDisabled,
        });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'You have saved the questionnaires.',
          });
          this.$emit('update:opened', false);
          this.$emit('refresh-questionnaires');
        }
      } catch (e) {
        console.log(e);
        // Sending a Sentry message because if this does fail during the API call,
        // it's likely that we messed something up, not them.
        Sentry.captureMessage(
          'selected questionnaires failed to update (in DisableEnableRemindersDialog)',
          { error: e, message: e.error_message },
        );
      }

      this.savingQuestionnaires = false;
    },
  },
};
</script>
